import { useState } from "react";
import useCustomQuery from "@/hooks/useCustomQuery";
import { Box, Button, Typography } from "@mui/material";
import { ClipLoader } from "react-spinners";
import { COLORS } from "@/constants/Colors/colors";
import { Bar } from "./atoms/Bar";
import { AddBar } from "./atoms/AddBar";
import { useSelector } from "react-redux";
export const Bars = () => {
  const lang = useSelector((state) => state?.global?.lang);
  const [add, setAdd] = useState(false);
  const globalState = useSelector((state) => state?.global);
  const { data, isPending } = useCustomQuery({
    key: ["bar", lang],
    url: "bar/getAll",
    select: (data) => data?.data?.data,
  });
  return (
    <Box
      sx={{
        width: "100%",
        padding: "20px",
        bgcolor: globalState?.isDarkMode ? COLORS.SOFT_DARK : COLORS.WHITE,
        fontFamily: "Noor-regular",
        borderRadius: 2,
        boxShadow: "0 0 8px rgba(0,0,0,0.1)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Noor-regular",
        }}
      >
        <Typography
          sx={{
            fontSize: "28px",
            fontFamily: "Noor-regular",
            color: COLORS.PRIMARY.MAIN,
          }}
        >
          {lang == "ar" ? "البانرز المثبتة" : "Pinned banners"}
        </Typography>
        <Button
          onClick={() => {
            setAdd(true);
          }}
          sx={{
            fontFamily: "Noor-regular",
            color: "white",
            bgcolor: COLORS.PRIMARY.MAIN,
            fontSize: "18px",
            "&:hover": { bgcolor: COLORS.SECONDARY.MAIN },
          }}
        >
          {lang == "ar" ? "أضف" : "Add"}
        </Button>
      </Box>
      {isPending && <ClipLoader size={60} />}
      {!isPending &&
        (() => {
          if (data?.length > 0) {
            return (
              <>
                {data?.map((item) => (
                  <Bar message={item} key={item.id} />
                ))}
              </>
            );
          } else {
            return (
              <Typography sx={{ fontFamily: "Noor-regular" }}>
                {lang == "ar"
                  ? "لا توجد بانرز مثبتة"
                  : "There is no Pinned banners"}
              </Typography>
            );
          }
        })()}
      <AddBar open={add} setOpen={setAdd} />
    </Box>
  );
};
